import React from "react";
import BaseComponent from "../../pages/base/BaseComponent";
import {Card} from "@themesberg/react-bootstrap";
import PropTypes from 'prop-types';
import label from "enqc-utilities/src/label/Label"
import ApplicationIcons from "enqc-utilities/src/misc/ApplicationIcons";

export default class AssemblerCard extends BaseComponent{
    constructor(props) {
        super(props);
        this.state = {
            user:this.props.user?this.props.user:{},
            imageCropper:false,
            imageBlob:undefined,
            imageUrl:undefined,
            changePasswordModal:false,
        }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props!=prevProps){
            let user = this.props.user?this.props.user:{}
            this.setState({user})
        }
    }

    render() {
        let {user} = this.props
        let manufacturingSite = user.manufacturingSite?user.manufacturingSite:{}
        return (
            <>
                <Card border="light" className="text-center p-0 mb-4">
                    <div className="profile-cover rounded-top bg-light" />
                    <Card.Body className="pb-4">
                        <Card.Img src={user.photoUrl?user.photoUrl:ApplicationIcons.Icons.userAvatar} alt={user.fullname}
                                  className="bg-white border-secondary user-avatar large-avatar rounded-circle mx-auto mt-n7 mb-4" />
                        <Card.Title>{label.LastPerformer}</Card.Title>
                        <br/>
                        <Card.Subtitle>{user.fullname}</Card.Subtitle>
                        <Card.Text className="text-gray">{user.email} / {manufacturingSite.name}</Card.Text>
                    </Card.Body>
                </Card>
                {super.render()}
            </>
        );
    }

}
AssemblerCard.propTypes = {
    user : PropTypes.any.isRequired,
    onRefresh: PropTypes.func.isRequired
}